import React from 'react';
import { Route } from 'react-router-dom';

import { ProductCatalog, Addons, ProductFields } from "pages";
import Fees from 'shared/Fees';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

export const PRODUCT_MANAGEMENT_ROUTES = [
    <Route index path='product-catalog' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PRODUCT_CATALOG_VIEW}><ProductCatalog /></RestrictedView>} />,
    <Route index path='addons' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PRODUCT_CATALOG_VIEW}><Addons /></RestrictedView>} />,
    <Route index path='fees' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PRODUCT_CATALOG_VIEW}><Fees type="fee" /></RestrictedView>} />,
    <Route index path='taxes' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PRODUCT_CATALOG_VIEW}><Fees type="tax" /></RestrictedView>} />,
    <Route index path='product-fields' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.PRODUCT_CATALOG_VIEW}><ProductFields /></RestrictedView>} />
];
